// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"079566f3","350":"cda78241","787":"05743aac"}[chunkId] + ".chunk.js";
};